var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00081 6.73221L1.5968 0.277422C1.42196 0.0994033 1.18831 0.000974603 0.939142 -4.10512e-08C0.688359 -0.000974685 0.452443 0.0971308 0.276313 0.274175C0.0988908 0.450244 0.000645984 0.685111 -3.52507e-07 0.935571C-3.52465e-07 0.936545 -3.52422e-07 0.93752 -3.5238e-07 0.938495C-3.41417e-07 1.18928 0.0972749 1.42545 0.274051 1.60314L7.34024 8.72095C7.5154 8.90092 7.7497 9 8.00081 9C8.25191 9 8.48363 8.90254 8.66008 8.72518L15.7272 1.60314C15.9034 1.4261 16 1.1909 16 0.940768C16 0.690632 15.903 0.452517 15.7256 0.273849C15.3624 -0.0867364 14.7713 -0.0867364 14.4061 0.275797L8.00081 6.73221Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e1245402.svg";
export { ForwardRef as ReactComponent };